import React, { Fragment } from 'react'
import { Typography, Button, Icon } from 'antd'
import NewHeader from '../../../components/NewHeader'
import history from '../../../history'

const { Title } = Typography
const QuestHeader = ({ t, type }) => {
  return (
    <Fragment>
      <NewHeader />
      <div className="create-quest" style={{ padding: "2rem 0", borderBottom: "1px solid #e8e8e8", marginBottom: "2rem" }}>
        <div className="create-quest__content">
          {type === "Create" && <Title level={4}>Create Quest</Title>}
          {type === "Update" && <Title level={4}>Edit Quest</Title>}
          <div>Create and edit your quest stops and locations</div>
        </div>
      </div>
    </Fragment>
  )
}

export default QuestHeader
